import { render, staticRenderFns } from "./ProductConfigurator.vue?vue&type=template&id=d6b34fb6&scoped=true&"
import script from "./ProductConfigurator.vue?vue&type=script&lang=js&"
export * from "./ProductConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b34fb6",
  null
  
)

export default component.exports